import React, { useEffect, useState } from 'react';

import { Dialog, Grid, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import useBlocRef from '../../utils/useBlocRef.hook';

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 10,
      marginRight: 10,
      width: '100%',
    },
  },
}));

export default () => {
  const classes = useStyles();
  const blocRef = useBlocRef('dialogBloc');
  const [dialogDetails, setDialogDetails] = useState(null);

  useEffect(() => {
    const sub = blocRef.current.dialogDetails$.subscribe(setDialogDetails);
    return () => sub.unsubscribe();
  }, []);

  const toggleDialog = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    if (!preventClose) {
      blocRef.current.toggleDialog(open);
    }
  };

  if (!dialogDetails) return null;

  const { dialogClasses, preventClose, ...detailsProps } = dialogDetails.props;
  const mergedDialogClasses = { paper: classes.paper, ...dialogClasses };

  return (
    <Dialog open={dialogDetails.open} maxWidth="lg" onClose={toggleDialog(false)} classes={mergedDialogClasses}>
      {dialogDetails.closeBtn && (
        <Grid container justify="flex-end">
          <IconButton aria-label="close" onClick={toggleDialog(false)}>
            <CloseIcon />
          </IconButton>
        </Grid>
      )}

      <dialogDetails.component {...detailsProps} />
    </Dialog>
  );
};
